<template>
  <ts-loading-banner :loading="loading">
    <Table 
      :data="resources" 
			:columns="columns" 
			size="small"
			highlight-row
      stripe
			max-height="700"
    >
        <template slot-scope="{ row }" slot="roleName">
          <span
            class="badge badge-primary mr-2"
            v-for="(role, index) in row.roles"
            :key="index"
            >{{ role.name == '*' ? 'Everything' : role.name }}</span
          >
        </template>
        <template slot-scope="{ row }" slot="mobileRole">
          {{ row.mobile_role ? row.mobile_role.description : null }}
        </template>
        <template slot-scope="{ row }" slot="reportName">
          {{ row.report_to ? row.report_to.name : null }}
        </template>
        <template slot-scope="{ row }" slot="disable">
          <span class="badge badge-success" v-if="!row.disable">Yes</span>
          <span class="badge badge-danger" v-else>No</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <a href="#" class="mr-2 text-info" @click.prevent="showModal(row)">
            <i class="fa fa-lock"></i>
          </a>
          <a href="#" class="mr-2 text-primary" @click.prevent="onEdit(row)">
            <i class="fa fa-edit"></i>
          </a>
        </template>
    </Table>
    <div class="d-flex justify-content-between align-items-center p-15">
      <ts-total-list v-model="pagination" />
      <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
    </div>
    <a-modal
      v-model="visible_resetpwd"
      :title="$t('user.resetPassword')"
      @ok="handleOk"
      @cancel="closeModal"
      width="20%"
      :okText="$t('save')"
      :confirmLoading="waiting"
      :cancelText="$t('cancel')"
      :maskClosable="false"
    >
      <div class="ts-space-y-3">
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">
              {{ $t('user.password') }}
            </label>
            <input
              v-model="model.new_password"
              type="password"
              class="form-control"
              :class="{ 'is-invalid': errors.has('new_password') }"
            />
            <div class="invalid-feedback" v-if="errors.has('new_password')">
              {{ errors.first('new_password') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">
              {{ $t('user.confirm') }}
            </label>
            <input
              v-model="model.password_confirmation"
              type="password"
              class="form-control"
              :class="{ 'is-invalid': errors.has('password_confirmation') }"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('password_confirmation')"
            >
              {{ errors.first('password_confirmation') }}
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </ts-loading-banner>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'userIndex',
  data() {
    return {
      numeric: 1,
      visible_resetpwd: false,
      loading: false,
      errors: new Errors(),
      waiting: false,
      user_type: 1,
      model: {
        user_id: 0,
        new_password: null,
        password_confirmation: null
      }
    }
  },
  computed: {
    ...mapState('security/user', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.security.user.search
      },
      set(newValue) {
        this.$store.commit('security/user/SET_SEARCH', newValue)
        this.$store.commit('security/user/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { 
          title: this.$t('user.branchName'),
          key: 'branch_name_en' 
        },
        { 
          title: this.$t('user.name'),
          key: 'name' 
        },
        { 
          title: this.$t('user.userName'),
          key: 'user_name' 
        },
        { 
          title: this.$t('user.roleName'),
          slot: 'roleName' 
        },
        { 
          title: this.$t('user.mobileRole'),
          slot: 'mobileRole' 
        },
        { 
          title: this.$t('user.reportTo'),
          slot: 'reportName' 
        },
        { 
          title: this.$t('user.active'),
          slot: 'disable' 
        },
        {
					title: this.$t('actions'),
					key: 'action',
					slot: 'action',
					fixed: 'right',
					align: 'center',
					width: 94
				}
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('security/user/fetch', attributes)
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onEdit(record) {
      this.$store.commit('security/user/SET_EDIT_DATA', record)
      this.$router.push({ name: 'user-edit', params: { id: record.user_id } })
    },
    showModal(record) {
      this.model.user_id = record.user_id
      this.visible_resetpwd = true
    },
    closeModal() {
      this.model.user_id = 0
      this.model.new_password = null
      this.model.password_confirmation = null
      this.visible_resetpwd = false
      this.errors = new Errors()
    },
    handleOk() {
      this.waiting = true
      this.$store
        .dispatch('security/user/passwordReset', {
          id: this.model.user_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.closeModal()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('security/user/RESET_STATE')
    next()
  }
}
</script>
